<div class="Footer" [ngClass]="{inverted: isInverted}">
    

    <div class="footerWrapper">

        <div class="legalLinksList">
            <div class="legalLinkItemHolder">
                <a href="https://www.lionsgate.com/legal/terms" target="_blank">
                    <span class="legalLinkItem">Terms of Use</span>
                </a>
            </div>
            <div class="legalLinkItemHolder">
                <a href="https://www.lionsgate.com/legal/privacy-policy" target="_blank">
                    <span class="legalLinkItem">Privacy Notice</span></a>
            </div>
            <div class="legalLinkItemHolder">
                <a href="https://www.lionsgate.com/legal/do-not-sell-my-information" target="_blank">
                    <span class="legalLinkItem">Do Not Sell / Share My Personal Information</span>
                </a>
            </div>
            <div class="legalLinkItemHolder"><a
                    href="https://www.lionsgate.com/legal/privacy-policy#CaliforniaResidents" target="_blank">
                    <span class="legalLinkItem">California Privacy Rights</span>
                </a>
            </div>
            <!-- <div class="legalLinkItemHolder">
                <div id="teconsent" class="visible"></div>
            </div> -->
        </div>

        <app-footer-trustarc></app-footer-trustarc>

        <div class='copy'>
            <span>
                ®, ™ & © {{ year }} Lions Gate Entertainment Inc. and related companies. All Rights Reserved.
            </span>
        </div>
    </div>

</div>